/**
 * Authoritative eligibility for the factory AuditEvent viewer (ENG-3351).
 * Display role alone is not sufficient — rbac must be ready and capability set.
 */
import type { Role } from '@/pages/users/types/rbac';
import type { UserPermissions } from '@/pages/users/types/permissions';

const AUDIT_LOG_ROLE_SLUGS: ReadonlySet<Role> = new Set(['unify-admin', 'unify-assistant']);

export function canAccessAuditLogsUi(input: {
  ready: boolean;
  role: Role;
  permissions: Partial<UserPermissions>;
}): boolean {
  if (!input.ready) return false;
  if (!AUDIT_LOG_ROLE_SLUGS.has(input.role)) return false;
  return input.permissions.can_see_audit_log_ui === true;
}
